import ChargerModule from '../../components/chargerModule';
import OpsSupportModule from './OpsSupportModule';

const OpsSupport = () => {
  const infoSideBar = { position: 'opsSupport' };

  return (
    <ChargerModule infoSideBar={infoSideBar}>
      <OpsSupportModule />
    </ChargerModule>
  );
};

export default OpsSupport;
